import {Component, OnDestroy, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {CodigoVinculoSmartPos, LicencasSmartPos, SmartPosAdminService, TerminalSmartPos} from '../../services/smartpos-admin.service';

const NOMES_PROVEDOR: Record<string, string> = {SIMULADOR: 'Simulador (testes)', STONE: 'Stone', PAGBANK: 'PagBank'};

@Component({
  selector: 'app-terminais-smartpos',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './terminais-smartpos.component.html',
  styleUrls: ['./terminais-smartpos.component.scss']
})
export class TerminaisSmartPosComponent implements OnInit, OnDestroy {
  terminais: TerminalSmartPos[] = [];
  licencas: LicencasSmartPos = {moduloAtivo: false, contratadas: 0, emUso: 0, valorMensalTerminal: null};
  carregando = true;
  erro = '';
  nomeTerminal = '';
  gerando = false;
  codigo: CodigoVinculoSmartPos | null = null;
  segundosRestantes = 0;
  revogando: TerminalSmartPos | null = null;
  motivoRevogacao = '';
  salvandoRevogacao = false;
  private relogio: any;

  constructor(private servico: SmartPosAdminService) {}

  ngOnInit(): void { void this.carregue(); }
  ngOnDestroy(): void { clearInterval(this.relogio); }

  get ativos(): TerminalSmartPos[] { return this.terminais.filter(t => t.situacao === 'ATIVO'); }
  get revogados(): TerminalSmartPos[] { return this.terminais.filter(t => t.situacao === 'REVOGADO'); }
  nomeProvedor(provedor: string): string { return NOMES_PROVEDOR[provedor] || provedor; }
  get licencasEsgotadas(): boolean { return this.licencas.moduloAtivo && this.licencas.emUso >= this.licencas.contratadas; }
  get tempoRestante(): string {
    const m = Math.floor(this.segundosRestantes / 60), s = this.segundosRestantes % 60;
    return `${m}:${String(s).padStart(2, '0')}`;
  }

  async carregue(): Promise<void> {
    this.carregando = true;
    this.erro = '';
    try {
      const painel = await this.servico.obtenhaPainel();
      this.terminais = painel.terminais;
      this.licencas = painel.licencas;
    }
    catch (erro) { this.erro = String(erro || 'Não foi possível carregar os terminais.'); }
    finally { this.carregando = false; }
  }

  async gereCodigo(): Promise<void> {
    if (!this.nomeTerminal.trim() || this.gerando || !this.licencas.moduloAtivo) return;
    this.gerando = true;
    this.erro = '';
    try {
      this.codigo = await this.servico.gereCodigo(this.nomeTerminal.trim());
      this.nomeTerminal = '';
      this.inicieContagem();
    } catch (erro) {
      this.erro = String(erro || 'Não foi possível gerar o código.');
    } finally {
      this.gerando = false;
    }
  }

  fecheCodigo(): void {
    clearInterval(this.relogio);
    this.codigo = null;
    void this.carregue();
  }

  abraRevogacao(terminal: TerminalSmartPos): void {
    this.revogando = terminal;
    this.motivoRevogacao = '';
  }

  async confirmeRevogacao(): Promise<void> {
    if (!this.revogando || !this.motivoRevogacao.trim() || this.salvandoRevogacao) return;
    this.salvandoRevogacao = true;
    this.erro = '';
    try {
      await this.servico.revogue(this.revogando.id, this.motivoRevogacao.trim());
      this.revogando = null;
      await this.carregue();
    } catch (erro) {
      this.erro = String(erro || 'Não foi possível revogar o terminal.');
    } finally {
      this.salvandoRevogacao = false;
    }
  }

  private inicieContagem(): void {
    clearInterval(this.relogio);
    const atualize = () => {
      this.segundosRestantes = Math.max(0, Math.round((new Date(this.codigo.expiraEm).getTime() - Date.now()) / 1000));
      if (!this.segundosRestantes) clearInterval(this.relogio);
    };
    atualize();
    this.relogio = setInterval(atualize, 1000);
  }
}
